import { StudentServiceInterface } from 'domain/services';
import {
  GetAllStudentsNotPaginatedUseCaseInterface,
  GetAllStudentsSelectOptionsUseCaseInterface,
  GetAllStudentsUseCaseInterface,
} from 'domain/usecases';

export class StudentService implements StudentServiceInterface {
  constructor(
    private readonly _getAllStudentsUseCase: GetAllStudentsUseCaseInterface,
    private readonly _getAllStudentsSelectOptionsUseCase: GetAllStudentsSelectOptionsUseCaseInterface,
    private readonly _getAllStudentsNotPaginated: GetAllStudentsNotPaginatedUseCaseInterface,
  ) {}

  async getAllStudents(
    params: GetAllStudentsUseCaseInterface.Params,
  ): Promise<GetAllStudentsUseCaseInterface.Result> {
    return await this._getAllStudentsUseCase.execute(params);
  }

  async getAllStudentsSelectOptions(
    params: GetAllStudentsSelectOptionsUseCaseInterface.Params,
  ): Promise<GetAllStudentsSelectOptionsUseCaseInterface.Result> {
    return await this._getAllStudentsSelectOptionsUseCase.execute(params);
  }

  async getAllStudentsNotPaginated(
    params: GetAllStudentsNotPaginatedUseCaseInterface.Params,
  ): Promise<GetAllStudentsNotPaginatedUseCaseInterface.Result> {
    return this._getAllStudentsNotPaginated.execute(params);
  }
}
